module.exports = "<div class=\"widget banner-slider-container\"><div class=\"banner-slider flexslider\"><ul class=\"banner-slider-list clearfix\"><li ng-show=$ctrl.ngAuthSettings.site.config.data.banners.showNews><a href=\"\"><img src=" + require("../../../../../assets/img/proyect-selected/modulo-noticias.jpg") + " alt=\"Banner Noticias\"></a><li><dynamic-banner db-data=$ctrl.shCtrl.globalBanners.sideTop db-name=sideTopBanner></dynamic-banner><li><dynamic-banner db-data=$ctrl.shCtrl.globalBanners.sideBottom db-name=sideTsideBottomBanneropBanner></dynamic-banner></ul></div></div><style></style>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/side-banners/side-banners.view.html
 ** module id = 508
 ** module chunks = 8
 **/